export default "__VITE_ASSET__c2019d19__"